// @flow

import {
  FETCH_SEARCH_NOTIFICATIONS,
  SET_SEARCH_NOTIFICATIONS,
  UPDATE_SEARCH_NOTIFICATION,
  UPDATE_SEARCH_NOTIFICATION_SUCCESS,
  RESTORE_SEARCH_NOTIFICATIONS,
} from './actionTypes';
import type {
  FetchSearchNotificationsAction,
  SetSearchNotificationsAction,
  SearchNotification,
  UpdateSearchNotificationAction,
  UpdateSearchNotificationSuccessAction,
  RestoreSearchNotificationsAction,
} from './types';

export function fetchSearchNotifications(): FetchSearchNotificationsAction {
  return {
    type: FETCH_SEARCH_NOTIFICATIONS,
  };
}

export function setSearchNotifications(
  searchNotifications: SearchNotification<*>[]
): SetSearchNotificationsAction {
  return {
    type: SET_SEARCH_NOTIFICATIONS,
    payload: {
      searchNotifications,
    },
  };
}

export function updateSearchNotification(
  searchNotification: SearchNotification<*>,
  partialSearchNotification: $Shape<SearchNotification<*>>
): UpdateSearchNotificationAction {
  return {
    type: UPDATE_SEARCH_NOTIFICATION,
    payload: {
      searchNotification,
      partialSearchNotification,
    },
  };
}

export function updateSearchNotificationSuccess(
  searchNotification: SearchNotification<*>
): UpdateSearchNotificationSuccessAction {
  return {
    type: UPDATE_SEARCH_NOTIFICATION_SUCCESS,
    payload: {
      searchNotification,
    },
  };
}

export function restoreSearchNotifications(
  searchNotifications: SearchNotification<*>[]
): RestoreSearchNotificationsAction {
  return {
    type: RESTORE_SEARCH_NOTIFICATIONS,
    payload: {
      searchNotifications,
    },
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/SearchNotifications/actions.js